import { Badge, Box, Card, Drawer, IconButton } from '@mui/material';
import { Clear, Notifications } from '@mui/icons-material';
import React, { useState } from 'react';
import Gene20Box from '../../../Components/Gene20Box/Gene20Box';
import { useTheme } from '@mui/system';
import useNotification from '../../../hooks/useNotification';
import { Link } from 'react-router-dom';
import { drawerWidth, topBarHeight } from '../../../utils/constant';
import { styled } from '@mui/styles';
import Gene20Button from '../../../Components/Gene20Button';
import Gene20Typography from '../../../Components/Gene20Typography';
import { getTimeDifference } from '../../../utils/utils';
const Notification = styled('div')(() => ({
  padding: '16px',
  marginBottom: '16px',
  display: 'flex',
  alignItems: 'center',
  height: topBarHeight,
  // boxShadow: themeShadows[6],
  '& h5': {
    marginLeft: '8px',
    marginTop: 0,
    marginBottom: 0,
    fontWeight: '500',
  },
}));

const NotificationCard = styled(Box)(({ theme }) => ({
  position: 'relative',
  '&:hover': {
    '& .messageTime': {
      display: 'none',
    },
    '& .deleteButton': {
      opacity: '1',
    },
  },
  '& .messageTime': {
    color: theme.palette.text.secondary,
  },
  '& .icon': { fontSize: '1.25rem' },
}));

const DeleteButton = styled(IconButton)(({ theme }) => ({
  opacity: '0',
  position: 'absolute',
  right: 5,
  marginTop: 9,
  marginRight: '24px',
  background: 'rgba(0, 0, 0, 0.01)',
}));

const CardLeftContent = styled('div')(({ theme }) => ({
  padding: '12px 8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: 'rgba(0, 0, 0, 0.01)',
  '& small': {
    fontWeight: '500',
    marginLeft: '16px',
    color: theme.palette.text.secondary,
  },
}));

const Heading = styled('span')(({ theme }) => ({
  fontWeight: '500',
  marginLeft: '16px',
  color: theme.palette.text.secondary,
}));
export default function Gene20NotificationBar({ container }) {
  const { deleteNotification, clearNotifications, notifications } = useNotification();
  const theme = useTheme();
  const secondary = theme.palette.text.secondary;
  const [panelOpen, setPanelOpen] = useState(false);
  const { palette } = useTheme();
  const textColor = palette.text.primary;
  const handleDrawerToggle = () => {
    setPanelOpen(!panelOpen);
  };
  return (
    <Gene20Box>
      <IconButton onClick={handleDrawerToggle}>
        <Badge color="secondary" badgeContent={notifications?.length}>
          <Notifications sx={{ color: textColor }} />
        </Badge>
      </IconButton>
      <Drawer
        width={'100px'}
        container={container}
        variant="temporary"
        anchor={'right'}
        open={panelOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <Gene20Box sx={{ width: drawerWidth }}>
          <Notification>
            <Notifications color="primary" />
            <h5>Notifications</h5>
          </Notification>

          {notifications?.map((notification) => (
            <NotificationCard key={notification.id}>
              <DeleteButton
                size="small"
                className="deleteButton"
                onClick={() => deleteNotification(notification.id)}
              >
                <Clear />
              </DeleteButton>
              <Link
                to={`/${notification.path}`}
                onClick={handleDrawerToggle}
                style={{ textDecoration: 'none' }}
              >
                <Card sx={{ mx: 2, mb: 3 }} elevation={3}>
                  <CardLeftContent>
                    <Gene20Box display="flex">
                      <IconButton> {notification.icon.name}</IconButton>
                      <Gene20Typography variant="heading">{notification.heading}</Gene20Typography>
                    </Gene20Box>
                    <Gene20Typography variant="small" className="messageTime">
                      {getTimeDifference(new Date(notification.timestamp))}
                      ago
                    </Gene20Typography>
                  </CardLeftContent>
                  <Gene20Box sx={{ px: 2, pt: 1, pb: 2 }}>
                    <Gene20Typography variant="p" sx={{ m: 0 }}>
                      {notification.title}
                    </Gene20Typography>
                    <Gene20Typography variant="small" sx={{ color: secondary }}>
                      {notification.subtitle}
                    </Gene20Typography>
                  </Gene20Box>
                </Card>
              </Link>
            </NotificationCard>
          ))}
          {!!notifications?.length && (
            <Gene20Box sx={{ color: secondary }}>
              <Gene20Button onClick={clearNotifications}>Clear Notifications</Gene20Button>
            </Gene20Box>
          )}
        </Gene20Box>
      </Drawer>
    </Gene20Box>
  );
}
